import { useState } from 'react';
import { api, type User } from '../api.js';

export function Login({ onSignedIn }: { onSignedIn: (user: User) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { user } = await api.login(email, password);
      onSignedIn(user);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'ورود ناموفق بود');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper-app p-4">
      <form onSubmit={submit} className="card w-full max-w-sm p-6">
        <div className="mb-5 flex items-center gap-2.5">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-ink-strong font-mono text-sm font-bold text-white">
            S
          </span>
          <span className="font-mono text-xs font-bold tracking-[.2em]" dir="ltr">
            SKINBOT
          </span>
        </div>
        <h1 className="mb-1 text-lg font-bold">پنل مدیریت</h1>
        <p className="mb-6 text-sm text-ink/50">دستیار فروش و مشاور پوست</p>

        <label className="mb-4 block">
          <span className="mb-1 block text-sm font-medium">ایمیل</span>
          <input
            className="input"
            type="email"
            dir="ltr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>

        <label className="mb-5 block">
          <span className="mb-1 block text-sm font-medium">رمز عبور</span>
          <input
            className="input"
            type="password"
            dir="ltr"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error && (
          <p className="mb-4 rounded-lg bg-bad-bg px-3 py-2 text-sm text-bad-deep">
            {error}
          </p>
        )}

        <button className="btn-primary w-full" disabled={busy}>
          {busy ? 'در حال ورود…' : 'ورود'}
        </button>
      </form>
    </div>
  );
}
